<template>
  <section class="msger">
    <main class="msger-chat w-full">
      <div
        v-for="(remark, index) in ticketRemarks"
        class="msg left-msg"
        :class="isCurrentUserPost(remark, 'ctr')"
        v-bind:key="index"
      >
        <div class="msg-bubble">
          <div class="msg-info">
            <div
              class="msg-info-name"
              v-if="isCurrentUserPost(remark, 'condition')"
            >
              {{ isAdmin ? "Support Team" : "You" }}
            </div>
            <div
              class="msg-info-name"
              v-if="!isCurrentUserPost(remark, 'condition')"
            >
              {{ !isAdmin ? "Support Team" : "User" }}
            </div>
          </div>

          <div
            class="msg-text text-left"
            :class="isCurrentUserPost(remark, 'txt')"
          >
            <span>{{ remark.detail }}</span>
            <span class="msg-info-time">
              {{
                moment(+remark.updatedOn)
                  .local()
                  .fromNow()
              }}
            </span>
          </div>
        </div>
      </div>
    </main>
  </section>
</template>

<script>
import firebase from "firebase";
import moment from "moment";

export default {
  name: "ChatList",
  data() {
    return {
      firebaseUser: {},
      moment: moment,
      isAdmin: false
    };
  },
  mounted() {
    this.firebaseUser = firebase.auth().currentUser;
    this.firebaseUser.getIdTokenResult().then(token => {
      this.isAdmin = token.claims.admin === true;
    });
  },
  computed: {},
  methods: {
    isCurrentUserPost(remark, type) {
      if (type == "ctr") {
        return this.firebaseUser && this.firebaseUser.uid == remark.updatedBy
          ? "right-msg"
          : "left-msg";
      } else if (type == "txt") {
        return this.firebaseUser && this.firebaseUser.uid == remark.updatedBy
          ? "text-right"
          : "text-left";
      } else {
        return this.firebaseUser && this.firebaseUser.uid == remark.updatedBy;
      }
    }
  },
  props: ["ticketRemarks"]
};
</script>

<style>
@import "../assets/styles/chat.scss";
</style>
